import { ActiveAlarm, SuppressedAlarm } from 'data/alarm/alarm.types';
import { AuditDetails, WithAuditDetails } from 'data/types';
import {
  AuditService,
  AuditActionType,
  getAuditDetails
} from 'shared/userAudit/audit-constants';

export default function getSuppressedAlarmPayload(
  auditEnabled: boolean,
  userId: string,
  userName: string,
  alarms: ActiveAlarm[]
): WithAuditDetails<SuppressedAlarm[]> {
  const suppressedAlarm : SuppressedAlarm[] = alarms.map((alarm) => {
    return {
      alarmid: alarm.alarmid,
      module: alarm.module,
      number: alarm.number,
      instance: alarm.instance,
      level: alarm.level,
      text: alarm.text,
      date: alarm.date,
      time: alarm.time,
      almGroupId: alarm.ss8group
    }
  })
  const ret: WithAuditDetails<SuppressedAlarm[]> = {
    data: suppressedAlarm
  };
  const fieldInfo: any = [];
  fieldInfo.push({
    field: 'suppressedAlarms',
    before: '',
    after: alarms
  });

  if (auditEnabled) {
    const auditDetails = getAuditDetails(
      auditEnabled,
      userId,
      userName,
      fieldInfo,
      userName,
      AuditService.ALARM,
      AuditActionType.ALARM_SUPPRESS
    ) as AuditDetails;
    ret.auditDetails = auditDetails;
  }
  return ret;
}
